export default `
.color-muted {
  color: #757575;
}
.color-wl {
  color: var(--primary-color);
}
.color-wl-light {
  color: var(--light-color);
}

.color-opacty-60 {
  opacity: 0.60;
}

.color-wl-black {
  color: ${props => props.theme.whitelabel?.theme?.text_primary_color};
}

.text-muted-wl {
--bs-text-opacity: 1;
color: var(--primary-color) !important;
}
`;
